import LegalCapitalTable from "./table";

const LegalCapital = () => {
  return (
      <LegalCapitalTable />
  );
};

export default LegalCapital;
